// Traduções francesas; preserva os textos originais do erro do GeoNature-citizen.
import { PT_BR } from './pt-BR';

export const FR: typeof PT_BR = {
    footer: {
        description: 'Observation, science et communauté.',
        about: 'À propos du projet',
        participate: 'Comment participer',
        terms: "Conditions d'utilisation",
        security: 'Signaler un problème de sécurité',
        privacy: 'Politique de confidentialité',
        contact: 'Contact',
    },
    notFound: {
        code: '404',
        originalError: 'Erreur 404',
        title: 'Page non trouvé',
        description: "Il semble que cette page n'existe pas.",
        backHome: "Retour à l'accueil",
        imageAlt: 'Un singe triste assis sur une branche',
    },
};
